import { type FunctionComponent, type ReactNode, type MouseEvent } from 'react';
import classnames from 'classnames';
import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight';
import styles from './styles/PageLinksArrowItem.scss';

type PageLinksArrowItemProps = {
    children: ReactNode;
    href?: string;
    isLeft?: boolean;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    dataTn?: string;
};

const PageLinksArrowItem: FunctionComponent<PageLinksArrowItemProps> = ({
    children,
    href,
    isLeft,
    onClick,
    dataTn,
}) => {
    const undefinedPropsControl: { href?: string } = {};
    if (href) {
        undefinedPropsControl.href = href;
    }
    return (
        <a
            {...undefinedPropsControl}
            onClick={onClick}
            className={classnames(styles.arrowItem, { [styles.isLeft]: isLeft })}
            data-tn={dataTn}
        >
            {!isLeft && children}

            <span className={classnames(styles.arrow, { [styles.isLeft]: isLeft })}>
                <ArrowRight />
            </span>

            {isLeft && children}
        </a>
    );
};

export { PageLinksArrowItem };
